import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingManagerService<T, P extends Promise<T>> {
  loading = signal(false);

  async load(promise: () => P): Promise<T> {
    this.loading.set(true);
    const res = await promise();
    this.loading.set(false);
    return res;
  }
}
